import { ENVS } from 'config/envVariables';

export const isProdEnv = () =>
  process.env.REACT_APP_FRONTEND_ENVIRONMENT === ENVS.PROD;
